import { Box, Grid } from "@mui/material";
import { CustomCard, CustomContent, formatPercent } from "./ApartmentsHelpers";
import { BoilerContent } from "./BoilerContent";
import { DefaultContent } from "./DefaultContent";
import { ChartSection } from "./ChartSection";
import { CardButtons } from "./CardButtons";

export const ApartmentCard = ({ item, boilerAparts }) => {
    const loadingValue = formatPercent(item.isBoiler, item.isBoiler ? item.BoilerOccup : item.loading);

    return (
        <Grid item md={12} lg={6} key={item.id}  sx={{ display: 'flex' }}>
            <CustomCard>
                <CustomContent>
                    {item.isBoiler ? <BoilerContent item={item} boilerAparts={boilerAparts} /> : <DefaultContent item={item} />}
                    <Box className={item.isBoiler ? "chart-box-wrapper" : ""} mt={2}>
                        <ChartSection loading={loadingValue} />
                    </Box>
                </CustomContent>
                <Box className="boiler-buttons-box">
                    <CardButtons apartmentId={item.id} />
                </Box>
            </CustomCard>
        </Grid>
    );
};